// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import iView from 'view-design'
import md5 from 'js-md5'
import i18n from '@/locale'
import config from '@/config'
import importDirective from '@/directive'
import { directive as clickOutside } from 'v-click-outside-x'
import installPlugin from '@/plugin'
import VCharts from 'v-charts'
import 'url-search-params-polyfill'

import './index.less'
import '@/assets/icons/iconfont.css'

// 自定义
import { SearchGroup, SearchGroupItem } from '_c/search-group/index.js'
import VueTablePage from '_c/tables/vue-table-page.vue'
import VTablePage from '_c/tables/v-table-page.vue'
import FormColItem from '_c/form/form-col-item.vue'
import { VueForm, VueFormItem } from '_c/form'

// 百度ueditor富文本编辑器
// import '../public/static/ueditor/ueditor.config.js'
// import '../public/static/ueditor/ueditor.all.js'
// import '../public/static/ueditor/ueditor.all.min.js'
// import '../public/static/ueditor/lang/zh-cn/zh-cn.js'
// import '../public/static/ueditor/ueditor.parse.min.js'
// import '../public/static/ueditor/themes/default/css/ueditor.css'

// import VOrgTree from 'v-org-tree'
// import 'v-org-tree/dist/v-org-tree.css'
// 实际打包时应该不引入mock
/* eslint-disable */
// if (process.env.NODE_ENV !== 'production') require('@/mock')

Vue.use(iView, {
  i18n: (key, value) => i18n.t(key, value)
})
// Vue.use(VOrgTree)
/**
 * @description 注册admin内置插件
 */
installPlugin(Vue)
/**
 * @description 生产环境关掉提示
 */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
Vue.prototype.$md5 = md5
/**
 * 注册指令
 */
importDirective(Vue)
Vue.directive('clickOutside', clickOutside)

// 查询控件
Vue.component('SearchGroup', SearchGroup)
Vue.component('SearchGroupItem', SearchGroupItem)
// 分页表格
Vue.component('VueTablePage', VueTablePage)
Vue.component('VTablePage', VTablePage)
// form列
Vue.component('VueForm', VueForm)
Vue.component('VueFormItem', VueFormItem)
// 下边以后作废
Vue.component('FormColItem', FormColItem)

Vue.use(VCharts)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js